import React, { useState, useEffect } from "react";

import { Link, useParams } from "react-router-dom";

import { useSelector } from "react-redux";

const Sidebar = () => {
  const { id } = useParams();

  const hash = window.location.hash.slice(5);

  const user = useSelector((state) => state.user.data);
  
    const phone = user?.phone;
    const email = user?.email;
    const username = user?.username;
    const studid = user?.stud_id;

  const [statuss, setStat] = useState(false);

  return (
    <>
      <div class="docs-nav-sidebar px-0 border-0">
        <div class="mt-12">

        </div>
        <div class="docs-nav px-5 ms-n4">
          <nav class="navigation navbar navbar-expand-sm">
            <div class="collapse navbar-collapse">
              <ul class="navbar-nav flex-column mt-2 ms-3">
                <li class="nav-item cursor-pointer mt-3">
                  <Link
                    to={"../" + id + "/home"}
                    class={hash === "/home" || hash === "/result" ? "nav-link active" : "nav-link"}
                  >
                    <i className="bi bi-house fs-3"></i>
                    <span className="fs-4 ms-2">Dashboard</span>
                  </Link>
                </li>

                {statuss ?
                  <>
                    <li class="nav-item cursor-pointer mt-3">
                      <Link
                        to={"../" + id + "/lecture"}
                        class={
                          hash === "/lecture" || hash === "/lecture"
                            ? "nav-link active"
                            : "nav-link"
                        }
                      >
                        <i class="bi bi-journal-bookmark-fill fs-3"></i>
                        <span className="fs-4 ms-2">Lecture</span>
                      </Link>
                    </li>

                    <li class="nav-item cursor-pointer mt-3">
                      <Link
                        to={"../" + id + "/work"}
                        class={
                          hash === "/work" || hash === "/work"
                            ? "nav-link active"
                            : "nav-link"
                        }
                      >
                        <i class="bi bi-person-workspace fs-3"></i>
                        <span className="fs-4 ms-2">Exercise</span>
                      </Link>
                    </li>

                    <li class="nav-item cursor-pointer mt-3">
                      <Link
                        to={"../" + id + "/result"}
                        class={
                          hash === "/result" || hash === "/result"
                            ? "nav-link active"
                            : "nav-link"
                        }
                      >
                        <i class="bi bi-graph-down-arrow fs-3"></i>
                        <span className="fs-4 ms-2">Result</span>
                      </Link>
                    </li>

                    <li class="nav-item cursor-pointer mt-3">
                      <Link
                        to={"../" + id + "/games"}
                        class={
                          hash === "/games" || hash === "/games"
                            ? "nav-link active"
                            : "nav-link"
                        }
                      >
                        <i class="bi bi-controller fs-3"></i>
                        <span className="fs-4 ms-2">Games</span>
                      </Link>
                    </li>

                    <li class="nav-item cursor-pointer mt-3">
                      <Link
                        to={"../" + id + "/settings"}
                        class={
                          hash === "/settings" || hash === "/settings"
                            ? "nav-link active"
                            : "nav-link"
                        }
                      >
                        <i class="bi bi-sliders fs-3"></i>
                        <span className="fs-4 ms-2">Settings</span>
                      </Link>
                    </li>
                  </>
                  :
                  <div className="mt-15 text-center">
                    <div class="spinner-grow text-success" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                }


              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
